import ApiLokalni from "../../ApiLokalni.ts";
import axios from "axios";

interface Article {
    id: string;
    profileId: string;
    key: string;
    textValue1:string;
}

interface Articles {
    articles: Article[];
}

class SeoArticleApi extends ApiLokalni {

    public constructor(token : string) {
        super(token);
    }

    public async articles() : Promise<Articles> {

        const url = this.getUrl() + '/api/v1/seo/articles';

        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
        }

        return {articles: []};
    }

}

export default SeoArticleApi;